import React from 'react';
import styled from 'styled-components/macro';

import data from './team';

const Container = styled.div``;

const Member = styled.div`
  border-top: solid 1px #9e9e9e50;
  padding: 30px 0 20px;
`;

const Name = styled.div`
  font-size: 22px;
  font-weight: 900;
  line-height: 1;
`;

const JobTitle = styled.div`
  font-size: 20px;
  font-weight: 300;
  line-height: 3;
`;

const SocialLink = styled.a.attrs(props => ({
  target: '_blank',
  rel: 'noopener noreferrer',
}))`
  font-size: 16px;
  font-weight: 200;
  line-height: 2;
  margin-right: 1em;
`;

const TeamList = () => (
  <Container>
    {data.map(teamMember => (
      <Member key={teamMember.name}>
        <Name>{teamMember.name}</Name>
        <JobTitle>{teamMember.job}</JobTitle>
        {teamMember.linkedIn && (
          <SocialLink href={teamMember.linkedIn}>LinkedIn</SocialLink>
        )}
        {teamMember.twitter && (
          <SocialLink href={teamMember.twitter}>Twitter</SocialLink>
        )}
      </Member>
    ))}
  </Container>
);

TeamList.propTypes = {};

TeamList.defaultProps = {};

export default TeamList;
